var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiniYerler = function SvgDiniYerler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#D45F5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.06 13.809a4.486 4.486 0 0 1-.776.504 4.419 4.419 0 0 1-5.967-1.956 4.442 4.442 0 0 1-.262-3.4 4.422 4.422 0 0 1 3.074-2.923.271.271 0 0 0-.066-.533l-.086-.001c-.868 0-1.701.2-2.477.596a5.457 5.457 0 0 0-2.727 3.197 5.483 5.483 0 0 0 .323 4.196 5.453 5.453 0 0 0 4.888 3.011 5.4 5.4 0 0 0 2.475-.597c.792-.404 1.48-1 1.992-1.726a.272.272 0 0 0-.036-.354.269.269 0 0 0-.354-.014Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.493 8.02a.137.137 0 0 0-.125-.096l-1.296-.036-.44-1.294a.136.136 0 0 0-.127-.094.136.136 0 0 0-.128.094l-.448 1.29-1.296.028a.137.137 0 0 0-.126.097c-.018.056 0 .119.044.156l1.022.857-.362 1.289a.145.145 0 0 0 .05.154.131.131 0 0 0 .155.005l1.08-.742 1.075.748a.131.131 0 0 0 .155-.003.146.146 0 0 0 .05-.154l-.354-1.292 1.026-.85a.146.146 0 0 0 .045-.156Z",
    fill: "#fff"
  })));
};
export default SvgDiniYerler;